/**
 * CODE_VERIFIERを作成します。
 * @returns CODE_VERIFIER
 */
export const createCodeVerifier = (): string => {
  const S = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~";
  const N = 43;
  return Array.from(crypto.getRandomValues(new Uint8Array(N)))
    .map((n) => S[n % S.length])
    .join("");
};

/**
 * CODE_CHALLANGEを作成します。
 * @param codeVerifier - CODE_VERIFIER
 * @returns CODE_CHALLANGE
 */
export const createCodeChallenge = async (codeVerifier: string): Promise<string> => {
  const sha = await sha256(codeVerifier);
  return base64urlencode(sha);
};

const sha256 = async (plain: string): Promise<ArrayBuffer> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return await window.crypto.subtle.digest("SHA-256", data);
};

const base64urlencode = (arrayBuffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(arrayBuffer);
  const len = bytes.byteLength;

  let str = "";
  for (let i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
